import React, {useEffect, useRef, useState} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import FormMultilineInput from "../../formComponents/FormMultilineInput";
import {clientDateToServerDate, serverDateToClientDate} from "../../utils/DateTimeUtil";
import FormUrlInput from "../../formComponents/FormUrlInput";
import {getShortName} from "../../utils/PersonNameUtil";
import {allAges, allArtistRoles, allSchoolClasses} from "../../data/Enums";
import FormRewardsSelect from "../../formComponents/FormRewardsSelect";

const EventDraftsDraftItemForm = ({initData, controlRef, pageOptions, readOnlyMode}) => {

    const controlRefName = useRef(null);
    const controlRefDescription = useRef(null);
    const controlRefCover = useRef(null);

    const controlRefCity = useRef(null);
    const controlRefLocation = useRef(null);
    const controlRefCustomLocation = useRef(null);

    const controlRefExpositionType = useRef(null);
    const controlRefTemporaryExpositionDates = useRef(null);
    const controlRefSeasonalExpositionDates = useRef(null);
    const controlRefOffDays = useRef(null);
    const controlRefArtists = useRef(null);
    const controlRefLiteraryWorks = useRef(null);
    const controlRefHistFigures = useRef(null);
    const controlRefSpheres = useRef(null);
    const controlRefTags = useRef(null);
    const controlRefIsSchoolProgram = useRef(null);
    const controlRefSchoolClasses = useRef(null);
    const controlRefSchoolClass = useRef(null);
    const controlRefSchoolSubject = useRef(null);
    const controlRefSchoolTheme = useRef(null);
    const controlRefMinAge = useRef(null);
    const controlRefRecommendedMinAge = useRef(null);
    const controlRefIsPushkinCardAccepted = useRef(null);
    const controlRefAwards = useRef(null);
    const controlRefOlympiads = useRef(null);
    const controlRefFestivals = useRef(null);
    const controlRefUrl = useRef(null);
    const controlRefVisitTypes = useRef(null);
    const controlRefArchived = useRef(null);

    const [selectedCityId, setSelectedCityId] = useState(initData?.refs?.locations?.[initData?.location_id ?? null]?.city_id);
    const [selectedLocationId, setSelectedLocationId] = useState(initData?.location_id);
    const [customLocationIncluded, setCustomLocationIncluded] = useState(Boolean(initData?.custom_location));

    const initExpositionType = initData?.museum_details?.exposition_type ?? null;
    const [expositionType, setExpositionType] = useState(initExpositionType);
    const [noExpoDates, setNoExpoDates] = useState(getInitialNoExpoDates(initData));
    const [isSchoolProgram, setIsSchoolProgram] = useState(getInitialIsSchoolProgram(initData))
    const [schoolClassId, setSchoolClassId] = useState(getInitialSchoolClassId(initData));
    const [schoolSubjectId, setSchoolSubjectId] = useState(getInitialSchoolSubjectId(initData))
    const [schoolThemeId, setSchoolThemeId] = useState(getInitialSchoolThemeId(initData))

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(500))
            isValid = false;

        if (!controlRefDescription.current.validateLength(2000))
            isValid = false;

        if (!controlRefCity.current.validateIsSelected("Нужно выбрать город!"))
            isValid = false;

        if (selectedCityId && !controlRefLocation.current.validateIsSelected("Нужно выбрать локацию!"))
            isValid = false;

        if (customLocationIncluded) {
            if (!controlRefCustomLocation.current.validateNotEmpty("Нужно указать место проведения (или убрать галку 'Событие на внешней площадке')!"))
                isValid = false;
            else if (!controlRefCustomLocation.current.validateLength(500))
                isValid = false;
        }

        if (!controlRefUrl.current.validateNotEmpty("Нужно указать сайт!"))
            isValid = false;
        else if (!controlRefUrl.current.validateUrl("Неверно указан адрес сайта!"))
            isValid = false;
        else if (!controlRefUrl.current.validateLength(2000))
            isValid = false;

        if (!controlRefAwards.current.validateYears())
            isValid = false;
        if (!controlRefOlympiads.current.validateYears())
            isValid = false;
        if (!controlRefFestivals.current.validateYears())
            isValid = false;

        if (!controlRefExpositionType.current.validateIsSelected("Нужно выбрать время экспозиции!"))
            isValid = false;

        if (expositionType === "temporary" && !noExpoDates) {
            if (!controlRefTemporaryExpositionDates.current.validateNotEmpty("Нужно указать даты или выбрать \"Даты выставки не указаны\" ниже!"))
                isValid = false;
            else if (!controlRefTemporaryExpositionDates.current.validateDates("Неверно указаны даты! Укажите обе даты в формате ДД.ММ.ГГГГ ; Также убедитесь, что дата начала не позже по времени, чем дата окончания. (если даты не указаны, выберите флажок ниже)"))
                isValid = false;
        } else if (expositionType === "seasonal") {
            if (!controlRefSeasonalExpositionDates.current.validateNotEmpty("Нужно указать даты!"))
                isValid = false;
            else if (!controlRefSeasonalExpositionDates.current.validateDates("Неверно указаны даты! Укажите обе даты в формате ДД.ММ"))
                isValid = false;
        }

        if (!controlRefSpheres.current.validateNotEmpty("Нужно указать хотя бы одну сферу!"))
            isValid = false;

        if (isSchoolProgram) {
            if (!controlRefSchoolClass.current.validateIsSelected("Нужно выбрать класс!"))
                isValid = false;

            if (!controlRefSchoolSubject.current.validateIsSelected("Нужно выбрать предмет!"))
                isValid = false;

            if (schoolSubjectId && schoolClassId) {
                if (!controlRefSchoolTheme.current.validateIsSelected("Нужно выбрать тему (или выбрать \"не указана\")!"))
                    isValid = false;
            }
        }

        if (!controlRefMinAge.current.validateIsSelected("Нужно выбрать возрастное ограничение!"))
            isValid = false;

        if (!controlRefVisitTypes.current.validateNotEmpty("Нужно указать хотя бы один вариант посещения!"))
            isValid = false;
        else if (!controlRefVisitTypes.current.validateItems())
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            kultural_goal: pageOptions.kultural_goal,
            type_id: 3, // TODO!
            name: controlRefName.current.getText(),
            description: controlRefDescription.current.getText(),
            cover_base64: controlRefCover.current.isChangedToImage() ? controlRefCover.current.getBase64() : null,
            clear_cover: controlRefCover.current.isChangedToCleared() ? true : null,
            location_id: selectedLocationId,
            custom_location: customLocationIncluded ? controlRefCustomLocation.current.getText() : null,
            exposition_type: expositionType,
            exposition_start: expositionType === "temporary" ?
                (noExpoDates ? null : clientDateToServerDate(controlRefTemporaryExpositionDates.current.getFromDate())) :
                expositionType === "seasonal" ?
                    clientDateToServerDate(`${controlRefSeasonalExpositionDates.current.getFromDate()}.2000`) : null,
            exposition_end: expositionType === "temporary" ?
                (noExpoDates ? null : clientDateToServerDate(controlRefTemporaryExpositionDates.current.getTillDate())) :
                expositionType === "seasonal" ?
                    clientDateToServerDate(`${controlRefSeasonalExpositionDates.current.getTillDate()}.2000`) : null,
            off_days: controlRefOffDays.current.getCheckedIds(),
            artists: getArtistsData(),
            literary_work_ids: controlRefLiteraryWorks.current.getSelectedIds(),
            sphere_ids: controlRefSpheres.current.getSelectedIds(),
            tag_ids: controlRefTags.current.getSelectedIds(),
            is_for_toddlers: controlRefSchoolClasses.current.getPreExtraItemChecked(),
            school_classes: controlRefSchoolClasses.current.getCheckedIds(),
            is_for_adults: controlRefSchoolClasses.current.getPostExtraItemChecked(),
            is_school_program: isSchoolProgram,
            school_class: isSchoolProgram && !schoolThemeId ? schoolClassId : null,
            school_subject_id: isSchoolProgram ? schoolSubjectId : null,
            school_theme_id: isSchoolProgram ? schoolThemeId : null,
            min_age: getAgeData(controlRefMinAge),
            recommended_min_age: getAgeData(controlRefRecommendedMinAge),
            is_pushkin_card_accepted: controlRefIsPushkinCardAccepted.current.getChecked(),
            reward_years: getRewardYearsData(),
            url: controlRefUrl.current.getUrl(),
            visit_types: controlRefVisitTypes.current.getItems(),
            is_deleted: initData && controlRefArchived.current.getChecked(),
        }
    }

    function getRewardYearsData() {
        const options = [...controlRefAwards.current.getSelectedOptions(), ...controlRefOlympiads.current.getSelectedOptions(), ...controlRefFestivals.current.getSelectedOptions()];
        return options.map(x => ({reward_id: x.id, year_start: x.year1, year_end: x.year2}));
    }

    function getArtistsData() {
        return [
            ...controlRefArtists.current.getSelectedIds().map(x => ({id: x, role: "painter"})), // TODO: omit role
            ...controlRefHistFigures.current.getSelectedIds().map(x => ({id: x, role: "historical_figure"})),
        ];
    }

    function renderInitialLiteraryWorkItemExtraInfo(item, className) {
        return <span className={className}>{getInitialAuthorName(item.id)}</span>
    }

    function getInitialAuthorName(literaryWorkId) {
        const work = initData?.refs?.literary_works?.[literaryWorkId];
        if (!work)
            return "?";

        if (work.author_id === null)
            return "(без автора)";

        const author = initData?.refs?.artists?.[work.author_id];
        return author ? getShortName(author.first_name, author.last_name, author.middle_name) : "?";
    }

    function renderInitialArtistItemExtraInfo(item, className) {
        return <span className={className}>{getInitialArtistMainRoleName(item.id)}</span>
    }

    function getInitialArtistMainRoleName(artistId) {
        const artist = initData?.refs?.artists?.[artistId];
        if (!artist)
            return "?";

        return allArtistRoles.find(x => x.id === artist.main_role)?.name ?? "?";
    }

    function renderInitialSchoolThemeItemExtraInfo(item, className) {
        return <span className={className} style={{textWrap: "nowrap"}}>{getInitialSchoolThemeClassName(item.id)}</span>
    }

    function getInitialSchoolThemeClassName(schoolThemeId) {
        const schoolTheme = initData?.refs?.school_themes?.[schoolThemeId];
        if (!schoolTheme)
            return "?";

        const classItem = allSchoolClasses.find(x => x.id === schoolTheme.class);
        return classItem ? classItem.name : "?";
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title="Основные">
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={500}
                    initValue={initData?.name ?? ""}
                    readOnly={readOnlyMode}
                />
            </FormBlock>
            <FormBlock title="Организатор и место проведения">
                <FormInput
                    controlRef={null}
                    label="Организатор"
                    widthLimit={500}
                    initValue={initData?.organizer ?? ""}
                    readOnly={readOnlyMode}
                />
                <FormInput
                    controlRef={null}
                    label="Город"
                    widthLimit={500}
                    initValue={initData?.city ?? ""}
                    readOnly={readOnlyMode}
                />
            </FormBlock>
            <FormBlock title="Время">
                <FormInput
                    controlRef={null}
                    label="Время экспозиции"
                    widthLimit={500}
                    initValue={initData?.exposition ?? ""}
                    readOnly={readOnlyMode}
                />
            </FormBlock>
            <FormBlock title="Инфо">
                <FormInput
                    controlRef={null}
                    label="Возрастное ограничение"
                    widthLimit={500}
                    initValue={initData?.age_limit ?? ""}
                    readOnly={readOnlyMode}
                />
                <FormInput
                    controlRef={null}
                    label="Пушкинская карта"
                    widthLimit={500}
                    initValue={initData?.pushkin_card ?? ""}
                    readOnly={readOnlyMode}
                />
                <FormUrlInput
                    controlRef={controlRefUrl}
                    label="Сайт (события)"
                    widthLimit={500}
                    initValue={initData?.event_url ?? ""}
                    placeholder="https://..."
                    readOnly={readOnlyMode}
                />
            </FormBlock>
            <FormBlock title="Варианты посещений">
                <FormMultilineInput
                    controlRef={null}
                    //label="Варианты посещений"
                    widthLimit={700}
                    initValue={initData?.visit_types ?? ""}
                    maxVisibleRows={6}
                    readOnly={readOnlyMode}
                />
                {/*<FormMuseumEventVisitsEditor
                    controlRef={controlRefVisitTypes}
                    initPresets={initData?.visit_types ?? []}
                    initDataRefs={initData?.refs}
                />*/}
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

function renderRewardsSelect(controlRef, label, initData, kind) {
    return <FormRewardsSelect
        controlRef={controlRef}
        selectedItemsAreaType="column"
        label={label}
        inputWidthLimit={450}
        selectedItemsAreaWidthLimit={700}
        initSelectedOptions={initData?.reward_years?.filter(x => getInitialRewardKindById(x.reward_id, initData) === kind).map(x => ({
            id: x.reward_id,
            year1: x.year_start ?? null,
            year2: x.year_end ?? null,
        })) ?? []}
        initRefList={initData?.refs?.rewards}
        apiName2="rewards"
        showIds={true}
        filterExtraParams={{kinds: kind}}
    />
}

function getInitialRewardKindById(rewardId, initData) {
    const result = initData?.refs?.rewards?.[rewardId]?.kind ?? "";
    if (!result)
        console.error(`can't detect reward kind from refs for rewardId=${rewardId}}`);
    return result;
}

const expositionTypes = [
    {id: "permanent", name: "постоянно"},
    {id: "seasonal", name: "сезонно"},
    {id: "temporary", name: "выставка"},
];

const minAgeOptions = [
    {id: -1, name: "(не указано)"},
    ...allAges
];

const recommendedMinAgeOptions = [
    {id: -1, name: "(не задана)"},
    ...allAges
];

function getAgeData(ageControlRef) {
    const selectedId = ageControlRef.current.getSelectedId();
    return selectedId === -1 ? null : selectedId;
}

function getInitialValueFromServerDate(src) {
    return src ? serverDateToClientDate(src) : "";
}

function getInitialValueFromServerDateWoYear(src) {
    if (!src)
        return "";

    const regex = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
    const match = regex.exec(src);
    if (!match)
        throw new Error(`invalid serverDate format: ${src}`);
    return `${match[3]}.${match[2]}`;
}

function compareClientDates(text1, text2) {
    const regex = /^\s*(\d{1,2})\s*\.\s*(\d{1,2})\s*\.\s*(\d{1,4})\s*$/;
    const match1 = regex.exec(text1);
    const match2 = regex.exec(text2);
    const year1 = parseInt(match1[3]);
    const year2 = parseInt(match2[3]);
    if (year1 !== year2)
        return year1 - year2;
    const month1 = parseInt(match1[2]);
    const month2 = parseInt(match2[2]);
    if (month1 !== month2)
        return month1 - month2;
    const day1 = parseInt(match1[1]);
    const day2 = parseInt(match2[1]);
    return day1 - day2;
}

function renderLiteraryWorkItemExtraInfo(item, className, dataRefs) {
    return <span className={className}>{getAuthorName(item.author_id, dataRefs)}</span>
}

function getAuthorName(authorId, dataRefs) {
    if (authorId === null)
        return "(без автора)";

    const author = dataRefs?.authors?.[authorId];
    return author ? getShortName(author.first_name, author.last_name, author.middle_name) : "?";
}

function renderArtistItemExtraInfo(item, className, dataRefs) {
    return <span className={className}>{allArtistRoles.find(x => x.id === item.main_role)?.name ?? "?"}</span>
}

function renderSchoolThemeItemExtraInfo(item, className, dataRefs) {
    const classItem = allSchoolClasses.find(x => x.id === item.class);
    if (!classItem)
        return null;
    return <span className={className} style={{textWrap:"nowrap"}}>{classItem.name}</span>
}

function renderCityItemExtraInfo(item, className, dataRefs) {
    if (item.is_region_city)
        return null;

    const regionTitle = dataRefs?.regions?.[item.region_id]?.name ?? "?";
    return <span className={className}>{regionTitle}</span>
}

function getInitialNoExpoDates(initData) {
    const details = initData?.museum_details;

    if (details?.exposition_type !== "temporary")
        return false;

    return !details.exposition_start && !details.exposition_end;
}

function getInitialIsSchoolProgram(initData) {
    return initData?.museum_details?.is_school_program ?? false;
}

function getInitialSchoolClassId(initData) {
    const initialThemeId = getInitialSchoolThemeId(initData);

    if (initialThemeId)
        return initData?.refs?.school_themes?.[initialThemeId]?.class ?? null;

    return getInitialIsSchoolProgram(initData) ? (initData?.museum_details?.school_class ?? null) : undefined;
}

function getInitialSchoolSubjectId(initData) {
    return getInitialIsSchoolProgram(initData) ? (initData?.museum_details?.school_subject_id ?? null) : undefined;
}

function getInitialSchoolThemeId(initData) {
    return getInitialIsSchoolProgram(initData) ? (initData?.museum_details?.school_theme_id ?? null) : undefined;
}


export default EventDraftsDraftItemForm;